var map = {
	"./awk.png": 4767,
	"./cloudscaling.png": 2464,
	"./dellemc.png": 6274,
	"./juniper.png": 1757,
	"./mailru.png": 8896,
	"./okb.png": 3568,
	"./opensdn.png": 3257,
	"./openstack.png": 3572,
	"./redhat.png": 1174,
	"./tf.png": 6556,
	"./tinkoff.png": 1155,
	"./vk.png": 2051,
	"./witology.png": 9286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7749;